export const VEHICLE_MAKES_MODELS = {
  Acura:      ['ILX', 'Integra', 'MDX', 'RDX', 'RLX', 'TLX', 'Other'],
  BMW:        ['3 Series', '5 Series', '7 Series', 'X3', 'X5', 'X7', 'Other'],
  Buick:      ['Enclave', 'Encore', 'Encore GX', 'Envision', 'LaCrosse', 'Verano', 'Other'],
  Cadillac:   ['CT4', 'CT5', 'CT6', 'Escalade', 'Escalade ESV', 'XT4', 'XT5', 'XT6', 'Other'],
  Chevrolet:  ['Blazer', 'Colorado', 'Equinox', 'Express Van', 'Impala', 'Malibu', 'Silverado', 'Suburban', 'Tahoe', 'Traverse', 'Other'],
  Chrysler:   ['300', 'Pacifica', 'Voyager', 'Other'],
  Dodge:      ['Challenger', 'Charger', 'Durango', 'Grand Caravan', 'Other'],
  FIAT:       ['500', '500L', '500X', 'Other'],
  Ford:       ['E-Series Van', 'Edge', 'Escape', 'Expedition', 'Explorer', 'F-150', 'F-250', 'Flex', 'Maverick', 'Ranger', 'Transit', 'Other'],
  Genesis:    ['G70', 'G80', 'G90', 'GV70', 'GV80', 'Other'],
  GMC:        ['Acadia', 'Canyon', 'Savana Van', 'Sierra', 'Terrain', 'Yukon', 'Other'],
  Honda:      ['Accord', 'CR-V', 'HR-V', 'Odyssey', 'Passport', 'Pilot', 'Ridgeline', 'Other'],
  Hummer:     ['H1', 'H2', 'H3', 'Other'],
  Hyundai:    ['Elantra', 'Palisade', 'Santa Fe', 'Sonata', 'Tucson', 'Other'],
  Infiniti:   ['Q50', 'Q60', 'QX50', 'QX55', 'QX60', 'QX80', 'Other'],
  Jaguar:     ['E-Pace', 'F-Pace', 'F-Type', 'I-Pace', 'XE', 'XF', 'Other'],
  Jeep:       ['Cherokee', 'Compass', 'Gladiator', 'Grand Cherokee', 'Wrangler', 'Other'],
  Kia:        ['Carnival', 'K5', 'Sedona', 'Sorento', 'Sportage', 'Telluride', 'Other'],
  Lexus:      ['GX', 'LX', 'LS', 'RX', 'Other'],
  Lincoln:    ['Aviator', 'Corsair', 'MKZ', 'Navigator', 'Nautilus', 'Other'],
  Mazda:      ['CX-5', 'CX-50', 'CX-90', 'Mazda3', 'Mazda6', 'MX-5 Miata', 'Other'],
  Mercedes:   ['GLE', 'GLS', 'Metris', 'S-Class', 'Sprinter', 'Other'],
  Mini:       ['Clubman', 'Convertible', 'Cooper', 'Countryman', 'Other'],
  Mitsubishi: ['Eclipse Cross', 'Galant', 'Mirage', 'Outlander', 'Outlander Sport', 'Other'],
  Nissan:     ['Altima', 'Armada', 'Frontier', 'Pathfinder', 'Quest', 'Rogue', 'Sentra', 'Titan', 'Other'],
  Ram:        ['1500', '2500', '3500', 'ProMaster', 'Other'],
  Rivian:     ['R1S', 'R1T', 'Other'],
  Scion:      ['FR-S', 'tC', 'xA', 'xB', 'xD', 'Other'],
  Subaru:     ['Ascent', 'Forester', 'Outback', 'Other'],
  Tesla:      ['Cybertruck', 'Model 3', 'Model S', 'Model X', 'Model Y', 'Other'],
  Toyota:     ['4Runner', 'Avalon', 'Camry', 'Corolla', 'Highlander', 'Land Cruiser', 'Prius', 'RAV4', 'Sequoia', 'Sienna', 'Tacoma', 'Tundra', 'Other'],
  Volkswagen: ['Atlas', 'Passat', 'Tiguan', 'Other'],
  Volvo:      ['S60', 'S90', 'V60', 'V90', 'XC40', 'XC60', 'XC90', 'Other'],
  Other:      ['Other'],
};

export const VEHICLE_COLORS = [
  'White', 'Silver', 'Gray', 'Black', 'Red', 'Blue', 'Green',
  'Gold', 'Tan', 'Brown', 'Orange', 'Yellow', 'Other',
];
